import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'payee-chip-dropdown',
  templateUrl: './chip-dropdown.component.html',
  styleUrls: ['./chip-dropdown.component.scss'],
  imports: [MatIcon],
})
export class ChipDropdownComponent implements AfterViewInit, OnDestroy {
  @Input() disableDropdown = false;
  @Input() selected: null | unknown = null;
  @Input() placeholder = '';

  @Output() removed = new EventEmitter<void>();

  @Input() dropdownOpen = false;
  @Output() dropdownOpenChange = new EventEmitter<boolean>();

  @ViewChild('dropdownMenu') dropdownMenu?: ElementRef;

  private readonly destroy = new Subject<void>();

  @Input() displayWith = (selected: any): string => selected;

  ngAfterViewInit() {
    // Subscribe to dropdownOpen changes
    this.dropdownOpenChange
      .pipe(takeUntil(this.destroy))
      .subscribe((isOpen) => {
        if (isOpen) {
          // Wait for the dropdown to be rendered
          setTimeout(() => {
            const firstInput =
              this.dropdownMenu?.nativeElement?.querySelector('input');
            if (firstInput) {
              firstInput.focus();
            }
          });
        }
      });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  openDropdown(): void {
    if (!this.disableDropdown) {
      this.dropdownOpen = true;
      this.dropdownOpenChange.emit(true);
    }
  }

  closeDropdown(): void {
    this.dropdownOpen = false;
    this.dropdownOpenChange.emit(false);
  }

  onClear(event: Event): void {
    event.stopPropagation();
    this.removed.emit();
  }
}
